/**
 * Sends logs to the console.
 */
export const consoleStream = (event) => event.error
    ? console[event.level](event.message, event.context, event.error)
    : console[event.level](event.message, event.context);
//# sourceMappingURL=consoleStream.js.map